import { render } from "./act-review-and-confirm.vue?vue&type=template&id=1b0e89ac&ts=true"
import script from "./act-review-and-confirm.ts?vue&type=script&lang=ts&external"
export * from "./act-review-and-confirm.ts?vue&type=script&lang=ts&external"

import "./act-review-and-confirm.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__